import { render, staticRenderFns } from "./ItemQuoteHistory.vue?vue&type=template&id=2024ded0"
import script from "./ItemQuoteHistory.vue?vue&type=script&lang=js"
export * from "./ItemQuoteHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports